import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuTableFilter]',
})
export class MuTableFilterDirective {
  @Input('appMuTableFilter') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
